export const APP_INITIAL_STATE: TroopState.AppState = {
  live: false,
};

export enum APP {
  START = "APP_START",
}
